var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabels116(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.396,
    height: 89,
    viewBox: "0 0 65.396 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_224",
    "data-name": "Grupo 224",
    transform: "translate(0.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_62",
    "data-name": "Trazado 62",
    d: "M7.07,0H58.327A6.844,6.844,0,0,1,65.4,6.593V82.407A6.844,6.844,0,0,1,58.327,89H7.07A6.844,6.844,0,0,1,0,82.407V6.593A6.844,6.844,0,0,1,7.07,0Z",
    transform: "translate(-0.377)",
    fill: "#2c3d71"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_223",
    "data-name": "Grupo 223",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_162",
    "data-name": "Rect\\xE1ngulo 162",
    width: 25,
    height: 7,
    transform: "translate(-0.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_178",
    "data-name": "Rect\\xE1ngulo 178",
    width: 24,
    height: 7,
    transform: "translate(27.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_166",
    "data-name": "Rect\\xE1ngulo 166",
    width: 25,
    height: 7,
    transform: "translate(-0.377 20)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_176",
    "data-name": "Rect\\xE1ngulo 176",
    width: 24,
    height: 7,
    transform: "translate(27.623 20)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_168",
    "data-name": "Rect\\xE1ngulo 168",
    width: 25,
    height: 7,
    transform: "translate(-0.377 39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_174",
    "data-name": "Rect\\xE1ngulo 174",
    width: 24,
    height: 7,
    transform: "translate(27.623 39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_170",
    "data-name": "Rect\\xE1ngulo 170",
    width: 25,
    height: 7,
    transform: "translate(-0.377 58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_172",
    "data-name": "Rect\\xE1ngulo 172",
    width: 24,
    height: 7,
    transform: "translate(27.623 58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_164",
    "data-name": "Rect\\xE1ngulo 164",
    width: 25,
    height: 7,
    transform: "translate(-0.377 10)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_177",
    "data-name": "Rect\\xE1ngulo 177",
    width: 24,
    height: 7,
    transform: "translate(27.623 10)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_165",
    "data-name": "Rect\\xE1ngulo 165",
    width: 25,
    height: 7,
    transform: "translate(-0.377 29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_175",
    "data-name": "Rect\\xE1ngulo 175",
    width: 24,
    height: 7,
    transform: "translate(27.623 29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_167",
    "data-name": "Rect\\xE1ngulo 167",
    width: 25,
    height: 7,
    transform: "translate(-0.377 49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_173",
    "data-name": "Rect\\xE1ngulo 173",
    width: 24,
    height: 7,
    transform: "translate(27.623 49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_169",
    "data-name": "Rect\\xE1ngulo 169",
    width: 25,
    height: 7,
    transform: "translate(-0.377 68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_171",
    "data-name": "Rect\\xE1ngulo 171",
    width: 24,
    height: 7,
    transform: "translate(27.623 68)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabels116);
export default __webpack_public_path__ + "static/media/labels1-16.6b2a7580.svg";
export { ForwardRef as ReactComponent };